// extracted by mini-css-extract-plugin
export default {"container":"unauthorized_container__a5Jed"};